import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e12c6948"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mainheadern col-11" }
const _hoisted_2 = { class: "hero mx-auto" }
const _hoisted_3 = { class: "heroheader" }
const _hoisted_4 = { class: "h1h text-center xmobile-8" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h1hdot" }, ".", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h1hdot" }, ".", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h1hdot" }, ".", -1))
const _hoisted_8 = { class: "heroheadertext" }
const _hoisted_9 = { class: "mhcta" }
const _hoisted_10 = {
  width: "201",
  height: "40",
  viewBox: "0 0 201 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "img-fluid"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "0.5",
  width: "200",
  height: "40",
  rx: "20",
  fill: "#75AE3D"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M163.517 26.3117C163.05 25.8384 163.05 25.0709 163.517 24.5975L168.055 20.0001L163.517 15.4026C163.05 14.9293 163.05 14.1618 163.517 13.6884C163.984 13.2151 164.742 13.2151 165.209 13.6884L170.594 19.143C171.061 19.6163 171.061 20.3838 170.594 20.8572L165.209 26.3117C164.742 26.7851 163.984 26.7851 163.517 26.3117Z",
  fill: "#161616"
}, null, -1))
const _hoisted_13 = ["font-size"]
const _hoisted_14 = {
  width: "162",
  height: "42",
  viewBox: "0 0 162 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "img-fluid"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M124.517 27.3117C124.05 26.8384 124.05 26.0709 124.517 25.5975L129.055 21.0001L124.517 16.4026C124.05 15.9293 124.05 15.1618 124.517 14.6884C124.984 14.2151 125.742 14.2151 126.209 14.6884L131.594 20.143C132.061 20.6163 132.061 21.3838 131.594 21.8572L126.209 27.3117C125.742 27.7851 124.984 27.7851 124.517 27.3117Z",
  fill: "#161616"
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "0.5",
  y: "1",
  width: "161",
  height: "40",
  rx: "20",
  stroke: "#737373"
}, null, -1))
const _hoisted_17 = ["font-size"]
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"boxarea\" data-v-e12c6948><div class=\"box1\" data-v-e12c6948></div><div class=\"box2\" data-v-e12c6948></div><div class=\"box3\" data-v-e12c6948></div><div class=\"box4\" data-v-e12c6948></div></div>", 1)
const _hoisted_19 = { class: "framearea" }
const _hoisted_20 = { class: "frame" }
const _hoisted_21 = { class: "frametitle" }
const _hoisted_22 = { class: "frametext" }
const _hoisted_23 = { class: "frame" }
const _hoisted_24 = { class: "frametitle" }
const _hoisted_25 = { class: "frametext" }


export default /*#__PURE__*/_defineComponent({
  __name: 'MainHeader',
  props: {
	options: Object
},
  setup(__props) {




const learnMore = () => {
	const classid = '.partnersarea';
	const yOffset = -150;
	const element = document.querySelector(classid);
	const y = element.getBoundingClientRect().top + window.scrollY + yOffset;

	window.scrollTo({ top: y, behavior: 'smooth' });
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('mainhero.title1', 'Tech Learning')), 1),
          _hoisted_5,
          _createTextVNode("  "),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('mainhero.title2', 'Smart Hiring')), 1),
          _hoisted_6,
          _createTextVNode("  "),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('mainhero.title3', 'Brands Rising')), 1),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('mainhero.subtext', 'One platform to learn tech skills and hire top talent—faster, smarter.')), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_router_link, {
          onClick: _ctx.$scrollToTop,
          to: "/s/gamedesign"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("svg", _hoisted_10, [
              _hoisted_11,
              _hoisted_12,
              _createElementVNode("text", {
                class: "heroheaderbuttontext",
                "font-size": _ctx.$t('mainhero.buttonfontsize', '16px'),
                x: "86.5",
                y: "22",
                "dominant-baseline": "middle",
                "text-anchor": "middle"
              }, _toDisplayString(_ctx.$t('mainhero.button1', 'Explore Courses')), 9, _hoisted_13)
            ]))
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createElementVNode("a", {
          role: "button",
          onClick: learnMore
        }, [
          (_openBlock(), _createElementBlock("svg", _hoisted_14, [
            _hoisted_15,
            _hoisted_16,
            _createElementVNode("text", {
              class: "heroheaderbuttontext",
              "font-size": _ctx.$t('mainhero.buttonfontsize', '16px'),
              x: "67",
              y: "22.5",
              "dominant-baseline": "middle",
              "text-anchor": "middle"
            }, _toDisplayString(_ctx.$t('mainhero.button2', 'Hire Talent')), 9, _hoisted_17)
          ]))
        ])
      ]),
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('mainhero.frame1title', 'Build Skills That Pay Off')), 1),
          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('mainhero.frame1text', 'Access age-adjusted courses in Game Design, Animation, Web Development, and more. Upskill students or yourself with industry-ready lessons designed to turn learning into earning.')), 1)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('mainhero.frame2title', 'Hire Smarter, Faster')), 1),
          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('mainhero.frame2text', 'Automate recruitment with tools that help you find and assess top talent efficiently. Whether you`re a company or school, connect with the right people — effortlessly.')), 1)
        ])
      ])
    ])
  ]))
}
}

})